import { useContext, useEffect } from 'react';
import SkeletonAssement from '../../components/assessment/SkeletonAssessment';
import WebsocketOverlays from '../../components/assessment/WebsocketOverlays.js';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import AwaitingAuthorizationDialog from '../../components/assessment/AwaitingAuthorizationDialog.js';
import CustomDialog from '../../components/ui/feedback/CustomDialog.js';
import * as TestStatus from '../../components/assessment/TestStatus.js';
import LearnosityContainer from '../../components/assessment/LearnosityContainer.js';
import AssessmentOverlays from '../../components/assessment/AssessmentOverlays.js';
import TestEventHandler from '../../components/assessment/TestEventHandler.js';
import PsychometricEventHandler from '../../components/assessment/PsychometricEventHandler.js';
import WebsocketMessageHandler from '../../components/assessment/WebsocketMessageHandler.js';
import WakeDetector from '../../components/worker/WakeDetector.js';
import LessSecure from '../../components/less-secure/LessSecure.js';
import AssessmentContainerLayout from '../../components/common/AssessmentContainerLayout.js';
import AwaitingLaunchDialog from '../../components/assessment/AwaitingLaunchDialog.js';
import useSessionStorage from '../../hooks/useSessionStorage.js';
import { STORAGE_STATUS_BEFORE_PAUSE } from '../../components/common/Storage.js';
import { useTranslation } from 'react-i18next';
import { setLanguageBasedOnPnp } from '../../i18n.js';

const Assessment = (props) => {
  const { testStatus, setExit } = useContext(AssessmentContext);
  const { getStorageItem } = useSessionStorage();
  const { t } = useTranslation();
  let statusBeforePause = getStorageItem(STORAGE_STATUS_BEFORE_PAUSE);
  const PROCTOR_DENIED_ACTIONS = [
    {
      label: t('common.ok'),
      handle: () => {
        setExit(true);
      },
    },
  ];

  //This useeffect handles refresh, make sure i18n uses the correct language based on pnp in storage
  useEffect(() => {
    setLanguageBasedOnPnp();
  }, [])
  

  return (
    <>
      <WebsocketOverlays />
      <AssessmentOverlays />
      <WebsocketMessageHandler />
      {testStatus === TestStatus.TEST_AWAITING_AUTHORIZATION && (
        <AwaitingAuthorizationDialog />
      )}
      {testStatus === TestStatus.TEST_AWAITING_LAUNCH && (
        <AwaitingLaunchDialog />
      )}
      {testStatus === TestStatus.TEST_DENIED && (
        <CustomDialog
          open={true}
          dialogProps={{
            title: t('pages.assessmentPage.awaitingAuthorization'),
            message: t('pages.assessmentPage.launchRejectedByProctor'),
            actions: PROCTOR_DENIED_ACTIONS,
          }}
        />
      )}
      <AssessmentContainerLayout>
        {(![
          TestStatus.TEST_LAUNCHED,
          TestStatus.TEST_INSESSION,
          TestStatus.TEST_PAUSED,
        ].includes(testStatus) ||
          (testStatus === TestStatus.TEST_PAUSED &&
            statusBeforePause === TestStatus.TEST_AWAITING_LAUNCH)) && (
          <SkeletonAssement />
        )}
        {([TestStatus.TEST_LAUNCHED, TestStatus.TEST_INSESSION].includes(
          testStatus,
        ) ||
          (testStatus === TestStatus.TEST_PAUSED &&
            statusBeforePause !== TestStatus.TEST_AWAITING_LAUNCH)) && (
          <div>
            <TestEventHandler />
            <PsychometricEventHandler />
            <LearnosityContainer />
            <WakeDetector />
            <LessSecure />
          </div>
        )}
      </AssessmentContainerLayout>
    </>
  );
};
export default Assessment;
